import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { confirmarCodigo, reenviarCodigo, passoFunilVaga, passoEntrar, criarDenuncia } from "../services/api";

import { payloadDoRelato, RASCUNHO_KEY } from "../components/ComplaintForm";
import { AvisoEmail, useCampoEmail } from "../components/AvisoEmail";
import BotaoGoogle from "../components/BotaoGoogle";
import BotaoLinkedin from "../components/BotaoLinkedin";

// 🚪 ONDE O /entrar PERDE GENTE (06/10/2026). Em dois dias foram 6 recuos aqui — um deles com um relato de 3 min
// escrito, que nunca foi publicado. O vigia só via "ficou Xs no /entrar"; não dava para saber se a pessoa nem
// tocou na tela, se digitou e desistiu, se deu erro ou se foi pelo Google/LinkedIn. Estes passos (anônimos,
// vaga 0, mesmo funil) respondem isso. A medição não muda nada do que a pessoa vê.
function origemDoDestino(d) {
  if (d === "/denunciar" || d === "/relatar") return "relato";
  if (d.startsWith("/curriculo")) return "curriculo";
  if (d === "/" ) return "direto";
  if (d.startsWith("/vagas/") || /^\/[a-z0-9-]+\/[a-z0-9-]+/.test(d)) return "vaga";
  return "outro";
}
function categoriaDoErro(msg) {
  const m = (msg || "").toLowerCase();
  if (m.includes("já") || m.includes("existe") || m.includes("cadastrad")) return "ja_existe";
  if (m.includes("senha")) return "senha";
  if (m.includes("e-mail") || m.includes("email")) return "email";
  return "outro";
}

export default function LoginPage() {
  const { login, registrar, loginGoogle, entrarComSessao } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  // ?redirect= existe porque link de E-MAIL não carrega o state do router: quem clica em "ver candidatura"
  // e cai no login precisa voltar exatamente para o candidato, não para a home.
  const _redir = new URLSearchParams(location.search).get("redirect");
  const destinoBase = location.state?.from || (_redir && _redir.startsWith("/") ? _redir : null) || "/";
  // O "porquê" vem do fluxo que trouxe a pessoa. ⚠️ ANTES só lia do state do router — e link de e-mail,
  // navegação com querystring e qualquer entrada externa perdem o state, então a explicação simplesmente
  // não aparecia. Quem chegava de uma vaga via só "Entrar / e-mail / senha", sem uma linha dizendo por que
  // precisa de conta (18/09/2026: 4 recuos em um dia, todos em menos de 1 min).
  const motivo = (location.state?.from ? location.state?.motivo : null)
    || new URLSearchParams(location.search).get("motivo");
  // Pré-seleção via query (?tipo=empresa&cadastro=1) — ex.: botão "Cadastrar empresa" cai direto no cadastro de EMPRESA.
  const _q = new URLSearchParams(location.search);
  const _cadastroQuery = _q.get("cadastro") === "1" || _q.get("modo") === "cadastro";
  const [modo, setModo] = useState((location.state?.from || _cadastroQuery) ? "cadastro" : "login");
  const [tipo, setTipo] = useState(_q.get("tipo") === "empresa" ? 1 : _q.get("tipo") === "parceiro" ? 3 : 0); // 0 candidato, 1 empresa, 3 parceiro
  // 🎓 Parceiro de capacitação recém-cadastrado vai direto para o cadastro em 8 etapas (22/10/2026).
  // 🧭 31/10/2026 (teste ponta a ponta): candidato e empresa recém-cadastrados caíam na HOME, sem próximo passo.
  // Sem destino de origem, o candidato vai montar o currículo (sem ele não há candidatura nem match) e a
  // empresa vai ao painel dela. Quem veio de uma vaga ou de um relato continua voltando para lá.
  const DESTINO_NOVA_CONTA = { 0: "/curriculo", 1: "/painel", 3: "/parceiro/cadastro" };
  const destino = modo === "cadastro" && destinoBase === "/" ? (DESTINO_NOVA_CONTA[tipo] || "/") : destinoBase;
  // 🔗 LINK DE REIVINDICAR (05/11/2026): ?tipo=empresa&cadastro=1&empresa=SoftExpert já traz o nome da empresa
  // preenchido. O cadastro liga a conta à empresa que tem EXATAMENTE esse nome (AuthEndpoints), então o link do
  // convite cai direto na página certa, com as vagas que já estão no ar.
  const [form, setForm] = useState({ nome: "", email: "", senha: "", nomeEmpresa: _q.get("empresa") || "" });
  const [erro, setErro] = useState(null);
  // So no CADASTRO: no login, apontar erro de digitacao no e-mail entregaria quais enderecos existem.
  const campoEmail = useCampoEmail(form.email, (v) => setForm((f) => ({ ...f, email: v })));
  const [carregando, setCarregando] = useState(false);
  const [cadastrouEmail, setCadastrouEmail] = useState(null); // != null → mostra popup pós-cadastro (confirmar e-mail por código)
  const [codigo, setCodigo] = useState("");
  const [codErro, setCodErro] = useState(null);
  const [codLoading, setCodLoading] = useState(false);
  const [reenviado, setReenviado] = useState(false);
  const [verificado, setVerificado] = useState(false);
  const [relatoPublicado, setRelatoPublicado] = useState(null); // id do relato publicado sozinho no cadastro
  const [erroRelato, setErroRelato] = useState(null); // por que o relato NÃO saiu sozinho (mensagem do backend)

  const set = (c) => (e) => setForm({ ...form, [c]: e.target.value });

  // 🚪 Medição do /entrar — ver o comentário no topo do arquivo.
  const medida = React.useRef({ estado: "sem_agir", fechado: false });
  const marcar = (estado) => { if (!medida.current.fechado) medida.current.estado = estado; };
  const concluir = (etapa) => { if (!medida.current.fechado) { medida.current.fechado = true; passoEntrar(etapa); } };
  React.useEffect(() => {
    if ((window.location.hash || "").startsWith("#li=")) { medida.current.fechado = true; return; } // volta do LinkedIn
    // destinoBase, não destino: a medição é de onde a pessoa VEIO; o pós-cadastro (/curriculo, /painel) não é origem.
    passoEntrar(`entrar_abriu_${origemDoDestino(destinoBase)}`);
    const sair = () => { if (!medida.current.fechado) { medida.current.fechado = true; passoEntrar(`entrar_saiu_${medida.current.estado}`); } };
    window.addEventListener("pagehide", sair);
    return () => { window.removeEventListener("pagehide", sair); sair(); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const enviar = async (e) => {
    e.preventDefault();
    setErro(null);
    setCarregando(true);
    passoEntrar(`entrar_enviou_${modo}`);
    try {
      if (modo === "login") {
        await login(form.email, form.senha);
        concluir("entrar_ok_login");
        navigate(destino);
      } else {
        // O destino vai no link do e-mail de confirmação, e uma cópia fica no navegador: quem confirmava pelo link
        // caía na home e perdia a vaga de onde veio (3 casos em 10/09/2026). Ver ConfirmarEmailPage.
        const destinoConfirmacao = destino !== "/" ? destino : null;
        try { if (destinoConfirmacao) localStorage.setItem("eairh_destino_confirmacao", destinoConfirmacao); } catch { /* sem storage: fica o link */ }
        await registrar({
          nome: form.nome, email: form.email, senha: form.senha,
          tipo: Number(tipo), nomeEmpresa: tipo === 1 || tipo === 3 ? (form.nomeEmpresa || null) : null, whatsapp: null,
          destino: destinoConfirmacao,
        });
        // 📝 PUBLICA O RELATO NA HORA EM QUE A CONTA NASCE. A pessoa já clicou em "Publicar" — só faltava a conta.
        // Em 10/09 a Lucimar escreveu 3 min, criou a conta, saiu na tela do código (foi buscar no Hotmail) e o
        // relato ficou só no navegador dela. Publicando aqui, não sobra passo para abandonar.
        // Exceção: informou e-mail do recrutador sem marcar ciência (LGPD) — aí volta ao formulário, que pergunta.
        if (destino === "/denunciar") {
          try {
            const r = JSON.parse(localStorage.getItem(RASCUNHO_KEY) || "null");
            const faltaCiencia = r && (r.contatoEmail || "").trim() && !r.cienteContato;
            // Tinha anexo? Não publica sozinho: o arquivo se perdeu no cadastro e não há onde anexar depois.
            if (r && (r.empresa || "").trim() && (r.titulo || "").trim() && (r.descricao || "").trim() && !faltaCiencia && !r.teveAnexos) {
              const nova = await criarDenuncia(payloadDoRelato(r, { nome: form.nome }));
              try { localStorage.removeItem(RASCUNHO_KEY); } catch { /* ok */ }
              setRelatoPublicado(nova.id);
            }
          } catch (e) {
            // 🚨 13/09 (cadastro 327): o backend recusou o rascunho (ex.: vácuo com menos de 5 dias) e este catch era
            // MUDO — a pessoa voltou ao formulário, o clique "não fez nada" e ela foi embora. Agora o motivo aparece
            // no bloco laranja. O rascunho continua no navegador e o botão leva de volta ao formulário para ajustar.
            setErroRelato(e.message || "Não foi possível publicar o relato.");
          }
        }
        concluir("entrar_ok_cadastro");
        setCadastrouEmail(form.email); // conta criada (auto-login já feito) → popup de boas-vindas; navega no "Continuar"
        // 📊 Fecha o funil da vaga: a pessoa veio de uma vaga (?redirect=) e CONCLUIU a conta. É o passo
        // que diz se a exigência de cadastro derruba mais gente em vaga de handoff — ver PassoFunilVaga.
        const daVaga = (destino || "").match(/^\/vagas\/(\d+)/);
        if (daVaga) passoFunilVaga(Number(daVaga[1]), "cadastrou");
      }
    } catch (e) {
      setErro(e.message || "Falha na autenticação.");
      passoEntrar(`entrar_erro_${modo}_${categoriaDoErro(e.message)}`);
      marcar("erro");
    } finally {
      setCarregando(false);
    }
  };

  // 🔑 Google: entra na conta que já existe com esse e-mail ou cria a de candidato (servidor decide).
  const comGoogle = async (credential) => {
    setErro(null); setCarregando(true);
    passoEntrar("entrar_google");
    try {
      const u = await loginGoogle(credential, destino !== "/" ? destino : null);
      concluir(u.novo ? "entrar_ok_google_novo" : "entrar_ok_google");
      if (u.novo) {
        const daVaga = (destino || "").match(/^\/vagas\/(\d+)/);
        if (daVaga) passoFunilVaga(Number(daVaga[1]), "cadastrou");
      }
      // Conta nova pelo Google é sempre de candidato: sem origem, vai ao currículo (mesma regra do cadastro).
      navigate(u.novo && destinoBase === "/" ? "/curriculo" : destino);
    } catch (e) {
      setErro(e.message || "Não foi possível entrar com o Google.");
      passoEntrar("entrar_erro_google"); marcar("erro");
    } finally { setCarregando(false); }
  };

  // 🔗 VOLTA DO LINKEDIN: a sessão vem no fragmento (#li=…, base64url) — ou o motivo do erro na query.
  const [erroLinkedin] = React.useState(() => {
    const m = { cancelado: "Você cancelou a entrada pelo LinkedIn.", sessao: "A entrada pelo LinkedIn expirou. Tente de novo.",
      email: "O LinkedIn não confirmou o seu e-mail. Entre com e-mail e senha.",
      empresa: "Contas de empresa entram com e-mail e senha. O acesso pelo LinkedIn é só para candidatos.",
      indisponivel: "Entrar com o LinkedIn ainda não está disponível.", falhou: "Não conseguimos entrar pelo LinkedIn agora. Tente de novo." };
    const k = new URLSearchParams(window.location.search).get("erroLinkedin");
    return k ? (m[k] || m.falhou) : null;
  });
  React.useEffect(() => {
    const h = window.location.hash || "";
    if (!h.startsWith("#li=")) return;
    try {
      const b64 = h.slice(4).replace(/-/g, "+").replace(/_/g, "/");
      const json = decodeURIComponent(escape(atob(b64 + "===".slice((b64.length + 3) % 4))));
      const s = JSON.parse(json);
      window.history.replaceState(null, "", window.location.pathname);   // tira o token da barra
      const u = entrarComSessao(s);
      // Conta nova pelo LinkedIn (só candidato) sem origem vai ao currículo, não à home (31/10/2026).
      const dest = s.destino && s.destino.startsWith("/") ? s.destino : (u?.novo ? "/curriculo" : "/");
      if (u.novo) { const daVaga = dest.match(/^\/vagas\/(\d+)/); if (daVaga) passoFunilVaga(Number(daVaga[1]), "cadastrou"); }
      navigate(dest, { replace: true });
    } catch { setErro("Não conseguimos concluir a entrada pelo LinkedIn. Tente de novo."); }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const inputCls = "w-full rounded-lg border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-primary outline-none";

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-md mx-auto px-4 py-10">
        <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          {motivo && (
            <div className="mb-5 rounded-xl border border-orange-200 bg-orange-50 p-3 text-sm text-orange-900">
              📣 {motivo}
            </div>
          )}
          <div className="flex gap-2 mb-6">
            <Tab ativo={modo === "login"} onClick={() => { setModo("login"); passoEntrar("entrar_aba_login"); marcar("trocou_aba"); }}>Entrar</Tab>
            <Tab ativo={modo === "cadastro"} onClick={() => { setModo("cadastro"); passoEntrar("entrar_aba_cadastro"); marcar("trocou_aba"); }}>Cadastrar</Tab>
          </div>

          {erro && <div role="alert" className="mb-4 rounded-lg border border-red-200 bg-red-50 p-3 text-red-700 text-sm">{erro}</div>}

          {/* 🏢 QUEM É VOCÊ, ANTES DE TUDO (05/11/2026, caso Luana/P&P Contabilidade). A escolha ficava DEPOIS dos
              botões Google/LinkedIn, que só criam conta de candidato: a empresa clicava no primeiro botão que via e virava
              "candidato" sem perceber — e depois não achava onde publicar vaga. Agora a pergunta vem primeiro. */}
          {modo === "cadastro" && (
            <div className="mb-5">
              <p className="mb-2 text-sm font-semibold text-gray-700">Quem é você?</p>
              <div className="grid grid-cols-3 gap-2">
                <TipoBtn ativo={tipo === 0} onClick={() => setTipo(0)}>🙋 Busco vaga</TipoBtn>
                <TipoBtn ativo={tipo === 1} onClick={() => setTipo(1)}>🏢 Empresa / recrutador</TipoBtn>
                <TipoBtn ativo={tipo === 3} onClick={() => setTipo(3)}>🎓 Professor / escola</TipoBtn>
              </div>
              {tipo === 1 && (
                <p className="mt-2 text-[12px] text-primary leading-relaxed">Conta de empresa: publique vagas grátis, receba candidatos e responda aos relatos.</p>
              )}
            </div>
          )}

          {/* Google: só para candidato. Empresa segue pelo cadastro normal (e-mail corporativo + aprovação). */}
          {erroLinkedin && !erro && <div role="alert" className="mb-4 rounded-lg border border-red-200 bg-red-50 p-3 text-red-700 text-sm">{erroLinkedin}</div>}
          {!(modo === "cadastro" && tipo !== 0) && (<>
            {/* O LinkedIn leva para fora do site: o clique fecha a medição como "foi ao LinkedIn", não como desistência. */}
            <div onClickCapture={() => concluir("entrar_linkedin")}>
              <BotaoLinkedin destino={destino !== "/" ? destino : null} />
            </div>
            <BotaoGoogle onCredencial={comGoogle} texto={modo === "cadastro" ? "signup_with" : "continue_with"} />
          </>)}

          <form onSubmit={enviar} onFocusCapture={() => { if (medida.current.estado === "sem_agir" || medida.current.estado === "trocou_aba") marcar("digitou"); }} className="space-y-4">
            {modo === "cadastro" && (
              <>
                {tipo === 3 && (
                  <p className="text-[11px] text-gray-600 leading-relaxed">🎓 Para escolas que oferecem bolsa e professores que oferecem aula experimental grátis a quem vem pelo eaiRH. Gratuito, sem comissão. Depois de criar a conta você preenche o cadastro, que passa por aprovação.</p>
                )}
                <input className={inputCls} autoComplete="name" aria-label={tipo === 1 ? "Seu nome (responsável)" : "Seu nome"} placeholder={tipo === 1 ? "Seu nome (responsável)" : "Seu nome"} value={form.nome} onChange={set("nome")} required />
                {/* Nome com cara de EMPRESA no cadastro de candidato (P&P "Contabilidade e Consultoria Empresarial"):
                    avisa e oferece trocar, sem bloquear: um falso positivo só custa um clique. */}
                {tipo === 0 && /\b(ltda|eireli|s\/?a|contabilidade|consultoria|assessoria|recursos humanos|rh|servi[cç]os|empresa|grupo|com[eé]rcio|ind[uú]stria)\b|&/i.test(form.nome) && (
                  <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-[12px] text-amber-900">
                    Parece o nome de uma empresa. Se você quer <b>publicar vagas</b>, crie a conta de empresa.
                    <button type="button" onClick={() => setTipo(1)} className="ml-1 font-bold text-primary underline">Mudar para Empresa / recrutador</button>
                  </div>
                )}
                {tipo === 1 && (
                  <input className={inputCls} aria-label="Nome da empresa" placeholder="Nome da empresa" value={form.nomeEmpresa} onChange={set("nomeEmpresa")} required />
                )}
              </>
            )}
            <input type="email" className={inputCls} autoComplete="email" aria-label="E-mail" placeholder={modo === "cadastro" && tipo === 1 ? "E-mail corporativo (ex: nome@suaempresa.com.br)" : "E-mail"} value={form.email}
              onChange={(e) => { set("email")(e); campoEmail.aoDigitar(); }} onBlur={campoEmail.aoSair} required />
            {modo === "cadastro" && <AvisoEmail {...campoEmail.aviso} />}
            {modo === "cadastro" && tipo === 1 && (
              <p className="text-[11px] text-primary -mt-1.5 leading-relaxed">📧 Use o e-mail <strong>corporativo</strong> da empresa. Gmail, Hotmail e Outlook não são aceitos para conta de empresa, e o cadastro passa por aprovação.</p>
            )}
            <input type="password" className={inputCls} aria-label="Senha" placeholder="Senha" value={form.senha} onChange={set("senha")}
              autoComplete={modo === "login" ? "current-password" : "new-password"} minLength={modo === "cadastro" ? 6 : undefined} required />

            <button type="submit" disabled={carregando}
              className="w-full bg-primary hover:opacity-90 disabled:opacity-60 text-white font-bold py-2.5 rounded-lg">
              {carregando ? "Aguarde..." : modo === "login" ? "Entrar" : "Criar conta"}
            </button>
            {modo === "cadastro" && (
              <>
                <p className="text-[11px] text-gray-500 mt-3 text-center leading-relaxed flex items-center justify-center gap-1">
                  🔒 Conexão segura (HTTPS). Sua senha é protegida e nunca fica visível — nem para a nossa equipe.
                </p>
                <p className="text-[11px] text-gray-400 mt-2 text-center leading-relaxed">
                  Seus dados são tratados conforme a <Link to="/privacidade" className="text-primary hover:underline">LGPD</Link>. Ao criar conta, você concorda com os <Link to="/termos" className="text-primary hover:underline">Termos de Uso</Link> e a <Link to="/privacidade" className="text-primary hover:underline">Política de Privacidade</Link>.
                </p>
              </>
            )}
          </form>

          {modo === "login" && (
            <p className="text-sm mt-4 text-center">
              <button type="button" onClick={() => { concluir("entrar_esqueci"); navigate(`/esqueci-senha${destino !== "/" ? `?redirect=${encodeURIComponent(destino)}` : ""}`); }} className="text-primary font-semibold hover:underline">
                Esqueci minha senha
              </button>
            </p>
          )}
        </div>
      </main>

      {/* Popup pós-cadastro: confirma o e-mail por CÓDIGO de 6 dígitos (com aviso de spam) — mesmo fluxo do cadastro de empresa. */}
      {cadastrouEmail && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 text-center">
            {verificado ? (
              <>
                <div className="text-4xl mb-1">✅</div>
                <h2 className="text-lg font-bold text-text">E-mail confirmado!</h2>
                <p className="text-sm text-gray-600 mt-2">Sua conta está <strong>✓ verificada</strong>. Bem-vindo(a) ao eaiRH!</p>
                <button onClick={() => navigate(destino, { replace: true })} className="mt-4 w-full rounded-xl bg-primary text-white font-semibold py-2.5 hover:opacity-90">
                  {destino === "/denunciar" ? "Voltar e publicar meu relato" : "Continuar"}
                </button>
              </>
            ) : (
              <>
                {/* 🚨 QUEM VEIO DE UM RELATO PRECISA SABER QUE ELE AINDA NÃO SAIU. Em 10/09 a Lucimar escreveu 3 min em
                    /denunciar, criou a conta, caiu aqui — que só falava em "selo verificado", com o caminho de volta num
                    "Confirmar depois" cinza no canto — e foi embora. O relato ficou só no navegador dela. */}
                {relatoPublicado && (
                  <div className="mb-4 rounded-xl border border-green-300 bg-green-50 p-3 text-left">
                    <p className="text-sm font-bold text-green-900">✅ Seu relato foi publicado!</p>
                    <Link to={`/relato/${relatoPublicado}`} className="text-sm text-green-800 font-semibold hover:underline">Ver meu relato →</Link>
                    <p className="text-[11px] text-green-800 mt-1">Vamos te avisar por e-mail se a empresa responder.</p>
                  </div>
                )}
                {destino === "/denunciar" && !relatoPublicado && (
                  <div className="mb-4 rounded-xl border border-orange-300 bg-orange-50 p-3 text-left">
                    <p className="text-sm font-bold text-orange-900">📝 Seu relato está guardado, mas ainda não foi publicado</p>
                    {erroRelato && (
                      <p role="alert" className="text-sm text-red-700 mt-1.5">⚠️ {erroRelato}</p>
                    )}
                    <button type="button" onClick={() => navigate(destino, { replace: true })}
                      className="mt-2 w-full rounded-xl bg-orange-600 hover:bg-orange-700 text-white font-semibold py-2.5">
                      {erroRelato ? "Voltar e ajustar meu relato" : "Voltar e publicar meu relato"}
                    </button>
                    <p className="text-[11px] text-orange-800 mt-2">Confirmar o e-mail é opcional agora — dá para fazer depois.</p>
                  </div>
                )}
                <div className="text-4xl mb-1">✉️</div>
                <h2 className="text-lg font-bold text-text">Confirme seu e-mail</h2>
                <p className="text-sm text-gray-600 mt-2">
                  Enviamos um <strong>código de 6 dígitos</strong> para <strong className="break-all">{cadastrouEmail}</strong>. Digite-o para ganhar o selo <strong>✓ verificado</strong>.
                </p>
                <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-2.5 mt-3 text-left">
                  📬 <strong>Não chegou em 1–2 minutos?</strong> Confira o <strong>spam / lixo eletrônico</strong> (e "Promoções", no Gmail) e marque como <strong>“não é spam”</strong>.
                </p>
                {codErro && <p role="alert" className="text-red-600 text-sm mt-3">{codErro}</p>}
                <form onSubmit={async (e) => {
                  e.preventDefault(); setCodErro(null); setCodLoading(true);
                  try { await confirmarCodigo(cadastrouEmail, codigo); setVerificado(true); passoEntrar("entrar_codigo_ok"); }
                  catch (err) { setCodErro(err.message || "Código inválido."); }
                  finally { setCodLoading(false); }
                }} className="mt-3 space-y-3">
                  <input className="w-full rounded-lg border border-gray-300 px-3 py-3 text-center text-2xl font-bold tracking-[0.5em] focus:ring-2 focus:ring-primary outline-none"
                    inputMode="numeric" autoComplete="one-time-code" maxLength={6} aria-label="Código de 6 dígitos" placeholder="••••••"
                    value={codigo} onChange={(e) => setCodigo(e.target.value.replace(/\D/g, "").slice(0, 6))} autoFocus required />
                  <button type="submit" disabled={codLoading || codigo.length !== 6}
                    className="w-full rounded-xl bg-primary disabled:opacity-60 text-white font-semibold py-2.5 hover:opacity-90">
                    {codLoading ? "Confirmando..." : "Confirmar e-mail"}
                  </button>
                </form>
                <div className="mt-3 flex items-center justify-between text-sm">
                  <button type="button" onClick={async () => { setCodErro(null); try { await reenviarCodigo(cadastrouEmail, destino !== "/" ? destino : null); } catch {} setReenviado(true); }}
                    className="text-primary font-semibold hover:underline">{reenviado ? "Código reenviado ✓" : "Reenviar código"}</button>
                  <button type="button" onClick={() => { passoEntrar("entrar_codigo_depois"); navigate(destino, { replace: true }); }} className="text-gray-500 hover:underline">Confirmar depois</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function Tab({ ativo, children, onClick }) {
  return (
    <button type="button" onClick={onClick} aria-pressed={ativo}
      className={`flex-1 py-2 rounded-lg font-semibold text-sm ${ativo ? "bg-primary text-white" : "bg-gray-100 text-gray-600"}`}>
      {children}
    </button>
  );
}
function TipoBtn({ ativo, children, onClick }) {
  return (
    <button type="button" onClick={onClick} aria-pressed={ativo}
      className={`flex-1 py-2 rounded-lg text-sm font-semibold border ${ativo ? "border-primary bg-blue-50 text-primary" : "border-gray-200 text-gray-500"}`}>
      {children}
    </button>
  );
}
